import { Builder } from '@builder.io/react'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import RecipeOrTreatAlterModal from 'components/ui/modal/RecipeOrTreatModalAlter'
import CdnImage from 'components/util/CdnImage'
import { getCognitoId, getVisitorId } from 'components/util/UserId'
import { Field, Formik } from 'formik'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'state'
import { createDogs, resetDogs } from 'state/actions/dogAction'
import { resetKey, updateKey } from 'state/actions/keyAction'
import { resetParent } from 'state/actions/parentAction'
import { addAddons, addRecipes, postPlanId, resetPlan } from 'state/actions/planAction'
import { getProducts } from 'state/actions/productsAction'
import { resetShipping } from 'state/actions/shippingAction'
import { DogType } from 'state/types/dogType'
import { RecipesSchema, TreatsSchema } from 'utils/yup-validation-schema'
import './index.css'
import { API } from 'aws-amplify'
import { Cache } from 'aws-amplify'
import { LinkButtonRegisterProps } from 'components/ui-builder/common/button'
import { triggerTagging } from 'components/util/common-utils'
import { getPersonalisedDataForAPI } from 'utils/personalise'
import * as yup from 'yup'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

enum Route {
  Sample = 'sample',
  Shop = 'shop'
}

interface SelectedPack {
  heading?: string
  subHeading?: string
  name: string
  description?: string
  packImage?: any
  packImageAlt?: string
  size: '250' | '600' | '1000' | ''
  quantity: number
}

interface ShopRouteConfiguration {
  heading: string
  subHeading: string
  flexibleQuantity: boolean
  packs: Pack[]
  displaySizes: boolean
  preSelectPack: boolean
}

interface Pack {
  name: string
  description: string
  packImage: any
  packImageAlt: string
  size: '250' | '600' | '1000' | ''
  quantity: number
}

interface Props {
  route: Route
  shopRouteConfiguration: ShopRouteConfiguration
  showAllRecipes: boolean
  recipesAvailable: any
  bloopersAvailable: any
  showPrices: boolean
  showAllAddons: boolean
  addonsAvailable: any
  backgroundColor: string
  mainHeading: string
  mainHeadingColor: string
  mainSubheading?: string
  textAlignment: Alignment
  topBanner: any
  topBannerMobile: any
  topImage: any
  topImageMobile: any
  topImageAlt: string
  footerImage: any
  footerImageMobile: any
  showTrustpilotImage: boolean
  widgetType: WidgetType
  widgetTags: string
  widgetColor: string
  buttonProp: LinkButtonProp
  buttonMessage: string
}

const ShopRouteAlternate = ({
  route,
  shopRouteConfiguration,
  showAllRecipes,
  recipesAvailable,
  bloopersAvailable,
  showPrices,
  showAllAddons,
  addonsAvailable,
  backgroundColor,
  mainHeading,
  mainHeadingColor,
  mainSubheading,
  textAlignment,
  topBanner,
  topBannerMobile,
  topImage,
  topImageMobile,
  topImageAlt,
  footerImage,
  footerImageMobile,
  showTrustpilotImage = false,
  widgetType,
  widgetTags,
  widgetColor,
  buttonProp,
  buttonMessage
}: Props) => {
  const {
    dogInfo,
    packNew
  }: {
    dogInfo: DogType
    packNew: PackNewType
  } = useSelector((state: RootState) => state.dog)
  const { recipesSelected, plan, changed, loading }: PlanType | any = useSelector((state: RootState) => state.plan)

  let { recipeList, addonList }: { recipeList: RecipeAddonType[]; addonList: RecipeAddonType[] } = useSelector(
    (state: RootState) => state.products
  )

  const [modalShow, setModalShow] = useState(false)
  const [modalActiveRecipe, setModalActiveRecipe] = useState({})
  const [showStickyFooter, setShowStickyFooter] = useState(false)

  const [recipeCount, setRecipeCount] = useState(0)
  const [recipes, setRecipes] = useState<Array<{ id: string; quantity: number }>>([])
  const [addons, setAddons] = useState<Array<{ id: string; quantity: number }>>([])

  const [packSize, setPackSize] = useState(0)
  const [selectedPack, setSelectedPack] = useState<SelectedPack | null>(null)

  const [showRecipePrices, setShowRecipePrices] = useState(false)
  const [showMinQuantityErrorMessage, setShowMinQuantityErrorMessage] = useState(false)
  const [showNoPackSelectedErrorMessage, setShowNoPackSelectedErrorMessage] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Used to update the plan
  const [storeRecipeIds, setStoreRecipeIds] = useState<Array<{ itemId: any; price: number }>>([])
  const [storeAddonIds, setStoreAddonIds] = useState<Array<{ itemId: any; price: number }>>([])

  const [cognitoId, setCognitoId] = useState('')
  const [visitorId, setVisitorId] = useState('')

  const dispatch = useDispatch()

  var formikRef = useRef<any>()

  const pageId = `${route}Route`

  // Default options
  const packOptions = [
    { value: 250, minQuantity: 12, maxQuantity: 55, standardPrice: 370, healthPlusPrice: 390 },
    { value: 600, minQuantity: 7, maxQuantity: 41, standardPrice: 760, healthPlusPrice: 800 },
    { value: 1000, minQuantity: 5, maxQuantity: 41, standardPrice: 1020, healthPlusPrice: 1080 }
  ]

  const currentPackOptionDefaults = packOptions.find(option => option.value === packSize) || {}

  const maxRecipeLimit =
    (!shopRouteConfiguration.flexibleQuantity && selectedPack && recipeCount >= selectedPack?.quantity) ||
    (shopRouteConfiguration.flexibleQuantity && recipeCount >= currentPackOptionDefaults?.maxQuantity)

  // Filter the recipes to be displayed
  // If showAllRecipes then include recipeList, recipesAvailable and bloopers
  // If !showAllRecipes then just show standard recipe list
  const filteredStoreRecipeIds = showAllRecipes
    ? [
        ...recipeList,
        ...recipesAvailable.filter(
          (available: any) => !recipeList.some((recipe: any) => recipe.itemId === available.itemId)
        ),
        ...(bloopersAvailable ?? []).filter(
          (blooper: any) =>
            !recipeList.some((recipe: any) => recipe.itemId === blooper.itemId) &&
            !recipesAvailable.some((available: any) => available.itemId === blooper.itemId)
        )
      ]
    : recipeList.filter((recipe: any) => recipesAvailable.some((available: any) => available.itemId === recipe.itemId))

  const filteredStoreAddonIds =
    addonsAvailable.length === 0
      ? addonList
      : addonList.filter((addon: any) => addonsAvailable.some((available: any) => available.itemId === addon.itemId))

  useEffect(() => {
    dispatch(getProducts())
    // Reset the store for clean run through this route
    dispatch(resetKey())
    dispatch(resetParent())
    dispatch(resetPlan())
    dispatch(resetShipping())
    dispatch(resetDogs())
    const callCognitoVisitorId = async () => {
      setCognitoId(await getCognitoId())
      setVisitorId(await getVisitorId())
    }
    callCognitoVisitorId()
    const clearKey = async () => {
      await dispatch(updateKey('checkout', null, location?.pathname, route.toUpperCase()))
    }
    clearKey()
  }, [])

  useEffect(() => {
    // Add route to pathname on gtag pageview events
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page: window.location.pathname + `/${pageId}`
      })
    }
  }, [])

  useEffect(() => {
    // Clear coupon cache
    if (route === 'shop') {
      Cache.setItem('coupon', '')
    }
  }, [route])

  useEffect(() => {
    if (showPrices || route === 'shop') {
      setShowRecipePrices(true)
    }
  }, [showPrices, route])

  useEffect(() => {
    // Set Pre select pack option
    if (shopRouteConfiguration?.packs?.length) {
      const preSelectedPack = shopRouteConfiguration.packs[0]
      setSelectedPack(preSelectedPack)
      setPackSize(parseInt(preSelectedPack.size))
    }
  }, [])

  useEffect(() => {
    // Add route pageview event
    const sendPageviewEvent = async () => {
      if (window?.location?.pathname) {
        if (visitorId) {
          await API.post('wwwREST', '/v1/public/event', {
            body: {
              path: window?.location?.pathname + `/${pageId}`,
              visitorId,
              name: 'pageview',
              personalise: getPersonalisedDataForAPI()
            }
          }).catch((err: any) => {
            console.error(JSON.stringify(err, null, 2))
          })
        }
      }
    }
    sendPageviewEvent()
  }, [visitorId])

  useEffect(() => {
    // Populate state and store
    updatePlanStore()
    updateDogStore()
  }, [])

  useEffect(() => {
    // Update state and store
    updatePlanStore()
    updateDogStore(formikRef?.current?.dogName)
  }, [formikRef?.current?.dogName, recipeCount, addons, selectedPack])

  useEffect(() => {
    //  Populate the state with the recipes and addons used
    if (packNew?.default === 'fullTrial' || packNew?.default === 'full') {
      const fullPlan = packNew.plans.find((plan: any) => plan.size === 'full')
      setStoreRecipeIds(fullPlan?.main.recipes?.length ? fullPlan.main.recipes : fullPlan?.trial.recipes)
      setStoreAddonIds(fullPlan?.main.addons?.length ? fullPlan.main.addons : fullPlan?.trial.addons)
    }
    if (packNew?.default === 'partialTrial' || packNew?.default === 'partial') {
      const partialPlan = packNew.plans.find((plan: any) => plan.size === 'partial')
      setStoreRecipeIds(partialPlan?.main.recipes?.length ? partialPlan.main.recipes : partialPlan?.trial.recipes)
      setStoreAddonIds(partialPlan?.main.addons?.length ? partialPlan.main.addons : partialPlan?.trial.addons)
    }
  }, [packNew])

  useEffect(() => {
    // Remove min quantity error message
    if (recipeCount > currentPackOptionDefaults.minQuantity) {
      setShowMinQuantityErrorMessage(false)
    }
  }, [recipeCount, currentPackOptionDefaults])

  useEffect(() => {
    // Remove pack selected error message
    if (packSize > 0) {
      setShowNoPackSelectedErrorMessage(false)
    }
    if (packSize > 0 && currentPackOptionDefaults.minQuantity > recipeCount) {
      setShowStickyFooter(true)
    }
  }, [packSize, currentPackOptionDefaults])

  useEffect(() => {
    const trustWidget = document.getElementById('trust-pilot-micro-combo')
    window.Trustpilot?.loadFromElement(trustWidget)
  }, [widgetType])

  useEffect(() => {
    const manageRedirect = async () => {
      if (changed && isSubmitting) {
        triggerTagging('shop_route_checkout_submit', pageId)
        await dispatch(updateKey('checkout', null, location?.pathname, route.toUpperCase()))
        if (dogInfo?.dogs[0]?.name && formikRef.current.values.dogName) {
          await updateDogStore(formikRef.current.values.dogName)
        }

        // Stop the scroll to the top of page on submit
        if (
          plan &&
          recipesSelected &&
          formikRef.current.values.dogName &&
          !showMinQuantityErrorMessage &&
          dogInfo?.dogs[0]?.name
        ) {
          history.replaceState({ scrollY: window.scrollY }, '')
          window.location.href = `/signup/checkout`
        }
      }
    }

    if (recipeCount >= currentPackOptionDefaults.minQuantity) {
      manageRedirect()
    }
  }, [changed, isSubmitting, plan, recipesSelected, recipeCount, formikRef, dogInfo.dogs])

  const validationSchema = yup.object({
    dogName: yup.string().required('Dog name is required')
  })

  const updatePlanStore = async () => {
    try {
      if (!storeRecipeIds?.length || !storeAddonIds?.length) {
        console.error('Missing recipes and addons to update the plan store')
        return false
      }

      let planId = `${packSize}g`
      let planObject = {
        planId,
        packSize,
        numberOfPacks: recipeCount,
        recipes: storeRecipeIds,
        addons: storeAddonIds
      }

      await dispatch(
        postPlanId({
          planId,
          planObject,
          noOfPacks: recipeCount,
          customOngoingNoOfPacks: recipeCount,
          packSize,
          weeks: undefined,
          isDefaultPlan: false,
          packType: 'CUSTOM', // 'SHOP',
          fixedOrCustomPlan: 'CUSTOM' //'SHOP'
        })
      )

      await dispatch(addRecipes(recipes, true))
      await dispatch(addAddons(addons))
      return true
    } catch (error) {
      console.error('Error in updatePlanStore:', error)
      return false
    }
  }

  const handleErrorScroll = (section: string) => {
    // Handle scroll to section with error
    if (section === 'minQuantityRecipeError') {
      setShowMinQuantityErrorMessage(true)
    }
    if (section === 'bundleSection') {
      setShowNoPackSelectedErrorMessage(true)
    }
    const errorSection = document.getElementById(section)
    if (errorSection) {
      errorSection.scrollIntoView({ behavior: 'smooth', block: 'center' })
      errorSection.focus()
    }
    setIsSubmitting(false)
    return
  }
  const handleSubmitToCheckout = async () => {
    setIsSubmitting(true)

    const errors = await formikRef.current?.validateForm()
    formikRef.current?.setTouched({
      dogName: true
    })

    if (errors && Object.keys(errors).length > 0) {
      if (errors.dogName) handleErrorScroll('dogNameField')

      setIsSubmitting(false)
      return
    }
    // Populate the dog name if not already populated
    // (Bypass race condition from clicking submit straight from entering dog name)
    if (formikRef.current.values.dogName) {
      await updateDogStore(formikRef.current.values.dogName)
    }

    if (packSize === 0) {
      handleErrorScroll('bundleSection')
    }

    if (selectedPack && recipeCount < currentPackOptionDefaults?.minQuantity) {
      handleErrorScroll('minQuantityRecipeError')
      setShowMinQuantityErrorMessage(true)
      return
    }
    if (cognitoId && cognitoId.trim() !== '') {
      // Redirect to account if logged in
      window.location.href = `/account`
      setIsSubmitting(false)
    } else {
      await updatePlanStore()
      // Use effect with changed will trigger the redirect when ready
      setIsSubmitting(false)
    }
  }

  const updateDogStore = async (dogName?: string) => {
    const dogData = {
      name: dogName ? dogName.charAt(0).toUpperCase() + dogName.slice(1) : '',
      breed: [],
      weight: 0,
      dob: '',
      exercise: '',
      physique: '',
      neutered: '',
      gender: '',
      medicalConditionOrAllergies: '',
      fussy: ''
    }
    await dispatch(
      createDogs({
        customer: dogInfo.customer,
        dogs: [dogData],
        visitorId
      })
    )
    return true
  }

  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const getRecipeQuantity = (recipeId: string) => {
    if (recipes) {
      const index = recipes.findIndex(recipe => recipe.id === recipeId)
      if (index !== -1) {
        return recipes[index].quantity
      }
    }
    return 0
  }

  const getAddonQuantity = (addonId: string) => {
    if (addons) {
      const index = addons.findIndex(addon => addon.id === addonId)
      if (index !== -1) {
        return addons[index].quantity
      }
    }
    return 0
  }

  const getRecipePrice = (recipe: string) => {
    if (
      currentPackOptionDefaults &&
      currentPackOptionDefaults.standardPrice &&
      currentPackOptionDefaults.healthPlusPrice
    ) {
      const recipeDetail = recipeList?.find((r: any) => r.itemId === recipe)
      if (recipeDetail?.range === 'health') {
        return (currentPackOptionDefaults.healthPlusPrice / 100).toFixed(2)
      } else {
        return (currentPackOptionDefaults.standardPrice / 100).toFixed(2)
      }
    }
  }

  const getAddonPrice = (addon: string) => {
    if (storeAddonIds) {
      const price = storeAddonIds?.filter((r: any) => r.itemId === addon)
      if (price?.length) return (price[0].price / 100).toFixed(2)
    }
  }

  const handleAddRecipe = (recipeId: string) => {
    setShowMinQuantityErrorMessage(false)
    let recipesFormData: any = []
    if (recipes) {
      const index = recipes.findIndex(recipe => recipe.id === recipeId)
      if (index !== -1) {
        const recipesArr = [...recipes]
        recipesArr[index].quantity = recipesArr[index].quantity + 1
        recipesFormData = [...recipesArr]
        setRecipes(recipesFormData)
      } else {
        recipesFormData = [...recipes, { id: recipeId, quantity: 1 }]
        setRecipes(recipesFormData)
      }
    } else {
      recipesFormData = [{ id: recipeId, quantity: 1 }]
      setRecipes(recipesFormData)
    }

    setRecipeCount(curr => curr + 1)
  }

  const handleRemoveRecipe = (recipeId: string) => {
    let recipesFormData: any = []
    if (recipes) {
      const index = recipes.findIndex(recipe => recipe.id === recipeId)

      if (index !== -1) {
        if (recipes[index].quantity > 1) {
          const recipesArr = [...recipes]
          recipesArr[index].quantity = recipesArr[index].quantity - 1
          recipesFormData = [...recipesArr]
          setRecipes(recipesFormData)
        } else {
          recipesFormData = recipes.filter(recipe => recipe.id !== recipeId)
          setRecipes(recipesFormData)
        }
        setRecipeCount(curr => curr - 1)
      }
    }
  }

  const handleAddAddon = (addonId: string) => {
    let addonsFormData: any = []
    if (addons) {
      const index = addons.findIndex(addon => addon.id === addonId)
      if (index !== -1) {
        const addonArr = [...addons]
        addonArr[index].quantity = addonArr[index].quantity + 1
        addonsFormData = [...addonArr]
        setAddons(addonsFormData)
      } else {
        addonsFormData = [...addons, { id: addonId, quantity: 1 }]
        setAddons(addonsFormData)
      }
    } else {
      addonsFormData = [{ id: addonId, quantity: 1 }]
      setAddons(addonsFormData)
    }
  }

  const handleRemoveAddon = (addonId: string) => {
    let addonsFormData: any = []
    if (addons) {
      const index = addons.findIndex(addon => addon.id === addonId)

      if (index !== -1) {
        if (addons[index].quantity > 1) {
          const addonsArr = [...addons]
          addonsArr[index].quantity = addonsArr[index].quantity - 1
          addonsFormData = [...addonsArr]
          setAddons(addonsFormData)
        } else {
          addonsFormData = addons.filter(addon => addon.id !== addonId)
          setAddons(addonsFormData)
        }
      }
    }
  }

  const getWidget = () => {
    return (
      <div>
        {/* <!-- TrustBox widget - Micro Combo --> */}
        <div
          className={`trustpilot-widget trustpilot-widget-black `}
          data-locale="en-GB"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="5af423d4a3303b0001bf47c1"
          data-style-height="14px"
          data-style-width="100%"
          // data-theme="light"
          data-stars="5"
          data-font-family="Montserrat"
          data-text-color={widgetColor ? widgetColor : ''}
          data-tags={widgetTags ? widgetTags : ''}
          id="trust-pilot-micro-combo"
        >
          <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener">
            <StaticImage
              objectFit="contain"
              className="w-full"
              src="../../../images/trustpilot-single-line.png"
              alt="Trustpilot"
            />
          </a>
        </div>
        {/* <!-- End TrustBox widget --> */}
      </div>
    )
  }

  const renderText = () => {
    return (
      <div className={`text-center lg:${getAlignmentClass()} pb-2 lg:pb-4 lg:mt-6 2xl:mt-10`}>
        <span className="text-2xl lg:text-4xl font-medium font-sans" style={{ color: mainHeadingColor }}>
          {mainHeading}
        </span>
        <br />

        {mainSubheading && <div className="pt-3" dangerouslySetInnerHTML={{ __html: mainSubheading }} />}
      </div>
    )
  }

  const renderFormSection = () => {
    return (
      <Formik
        innerRef={formikRef}
        initialValues={{
          dogName: ''
        }}
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnBlur={true}
        onSubmit={values => {
          updateDogStore(values.dogName)
        }}
      >
        {formikProps => (
          <div className="w-full">
            <span className="text-base font-semibold mb-4 flex justify-center whitespace-nowrap text-center font-sans">
              Who are we feeding?
            </span>

            {/* Dog Name Field */}
            <div
              id={pageId}
              className="relative flex flex-col w-5/6 lg:w-full flex-shrink-0 items-center justify-center mx-auto"
            >
              <label className={`mx-auto flex w-full flex-col`}>
                <div id={'dogNameField'} className="relative w-full max-w-[45rem] mx-auto">
                  <Field
                    type="text"
                    id={'dogName'}
                    name={'dogName'}
                    className="w-full self-center rounded-full border-2 border-gray-200 bg-white py-4 px-6 text-center focus:border-highlight focus:ring-highlight text-base font-sans font-semibold text-[#006685] placeholder-[#006685]"
                    placeholder="Your dog’s name"
                    onChange={(e: any) => {
                      formikProps.setFieldValue('dogName', e.target.value)
                    }}
                    onBlur={async (e: any) => {
                      updateDogStore(formikProps.values.dogName)
                      if (formikProps.errors.dogName) {
                        formikProps.setFieldError('dogName', '')
                      }
                    }}
                  />
                </div>

                {formikProps.touched.dogName && formikProps.errors.dogName && (
                  <div className="text-center text-xs text-red-500 pt-2">{formikProps.errors.dogName}</div>
                )}
              </label>
            </div>
          </div>
        )}
      </Formik>
    )
  }

  const renderBundles = () => {
    return (
      <>
        {' '}
        {showNoPackSelectedErrorMessage && (
          <div className="text-center text-sm mb-6 text-red-500">Please select a pack size</div>
        )}{' '}
        <div
          id="bundleSection"
          className={`${shopRouteConfiguration.packs.length > 3 ? 'grid grid-cols-2 lg:grid-cols-4' : 'flex flex-row '} gap-x-2 xs:gap-x-4 md:gap-x-8 lg:gap-x-16 w-full justify-center mx-auto 2xl:max-w-[75%] items-stretch my-8`}
        >
          {shopRouteConfiguration.packs.map((pack: any, index: number) => (
            <div
              key={index}
              className={`fade-fussy-show mb-4 flex flex-col flex-1 md:flex-none md:mb-0 w-auto mx-1 lg:mx-0`}
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <button
                className={`bg-white flex flex-col sm:flex-row lg:flex-col items-center justify-center rounded-3xl sm:px-2 md:px-8 lg:px-12 hover:bg-[#B0CDD5] focus:bg-[#B0CDD5] border-2 border-[#006685] py-2 lg:py-0 lg:min-h-[100px] transition-all duration-300 hover:scale-105 h-full
  ${selectedPack?.name === pack.name ? 'bg-[#B0CDD5] border scale-110 lg:min-h-[120px] lg:px-10 md:px-8 sm:px-6' : ''}`}
                type="button"
                onClick={() => {
                  triggerTagging('shop_route_bundle_selected', 'shop_route', parseInt(pack.size))
                  setPackSize(parseInt(pack.size))
                  setSelectedPack(pack)
                  setShowRecipePrices(true)
                }}
              >
                {pack.planImage && (
                  <CdnImage
                    className="block h-12 w-12 object-contain center items-center lg:h-24 aspect-auto lg:w-24 pr-1 lg:pr-0"
                    url={pack.planImage}
                    alt={pack.planImageAlt}
                  />
                )}

                <div className="flex flex-col justify-end lg:justify-center items-center sm:items-start lg:items-center text-left sm:text-center">
                  <span className="lg:px-2 lg:p-2 font-sans font-bold text-sm lg:text-base">{pack.name}</span>
                  {pack.description && <div dangerouslySetInnerHTML={{ __html: pack.description }} />}
                </div>
              </button>
            </div>
          ))}
        </div>
      </>
    )
  }

  const renderRecipeSection = () => {
    return (
      <div className={`flex center mt-4 mb-6 rounded-3xl bg-white lg:w-full lg:container`}>
        <Formik
          initialValues={{ recipes: [] }}
          validationSchema={RecipesSchema}
          onSubmit={async () => {
            dispatch(addRecipes(recipes, true))
            await updatePlanStore()
          }}
          validateOnMount
        >
          {props => {
            return (
              <div className={`relative my-4`}>
                <div className={`p-2 pt-3 lg:py-4 w-full mx-auto lg:w-auto`}>
                  <p className="font-sans font-semibold text-base text-center mx-auto pb-6">
                    Choose from our selection of recipes
                  </p>
                  <div
                    id="minQuantityRecipeError"
                    className={`w-full text-center ${showMinQuantityErrorMessage ? 'mb-2' : 'mb-6'}`}
                  >
                    <p>
                      You have{' '}
                      <span className="rounded bg-[#F58C82] p-2 text-lg font-bold text-white">{recipeCount}</span>
                      &nbsp;packs selected
                    </p>
                  </div>
                  {showMinQuantityErrorMessage && (
                    <div className="text-center text-sm mb-6 text-red-500">
                      You need a minimum of &nbsp;{currentPackOptionDefaults?.minQuantity}
                      &nbsp; recipes.
                    </div>
                  )}

                  <ul className="mx-auto grid w-full gap-y-6 gap-x-3 xs:gap-x-8 xs:p-4 pt-0 grid-cols-2 md:max-w-[80%] lg:grid-cols-3">
                    {recipeList &&
                      recipeList
                        .filter(
                          recipe =>
                            recipe.status !== 'OUTOFSTOCK' &&
                            filteredStoreRecipeIds.some((r: any) => r.itemId === recipe.itemId)
                        )
                        .map((recipe: { itemId: string; name: string; imageUrlNormal: string }, _key: number) => {
                          const selectedRecipe = recipes?.find(r => r.id === recipe.itemId)

                          return (
                            <li
                              className={`relative overflow-hidden rounded-3xl bg-[#F8F2EC] ${selectedRecipe && 'shadow-[0_0_0_4px_rgba(0,102,133,1)]'}`}
                              key={recipe.itemId}
                            >
                              <div className={`flex h-full flex-col justify-between text-center`}>
                                <div className="flex h-full flex-col">
                                  <div className="block grid-cols-3 md:grid md:grid-cols-1">
                                    <div className="aspect-h-1 relative mx-auto w-full overflow-hidden md:rounded-none lg:h-[180px] xl:h-[220px]">
                                      {recipe?.images?.primary && (
                                        <CdnImage
                                          url={recipe?.images?.primary}
                                          alt={recipe.name}
                                          steps={[550]}
                                          className={`block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full lg:hidden`}
                                        />
                                      )}
                                      {recipe?.images?.noBackground && (
                                        <CdnImage
                                          url={recipe?.images?.noBackground}
                                          alt={recipe.name}
                                          steps={[550]}
                                          className={`hidden max-h-[150px] w-full scale-150 transform object-contain xs:min-h-[120px] xs:object-cover md:max-h-full md:scale-100 lg:block bg-[#F6E9DB]`}
                                        />
                                      )}
                                    </div>
                                    <div className="col-span-2 flex h-auto flex-grow flex-col">
                                      {recipe.adultOnly && (
                                        <div className="flex w-full justify-center text-center font-sans font-medium text-sm">
                                          <span className="bg-[#E79085] py-2 mb-1 md:mb-0 whitespace-normal break-words w-full">
                                            Unsuitable for puppies & pregnant/nursing dogs
                                          </span>
                                        </div>
                                      )}
                                      <div className="col-span-2 flex h-auto flex-grow flex-col py-4 px-1 xs:p-4">
                                        <h4 className="font-sans font-semibold text-center md:text-xl">
                                          {recipe.name}
                                        </h4>
                                        <p className="mt-4 flex h-full flex-grow flex-col text-center text-xs text-black md:text-sm">
                                          {recipe.shortDescription}{' '}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <button
                                  className="pb-2.5 text-xs text-black underline sm:text-sm"
                                  onClick={() => {
                                    setModalShow(true)
                                    setModalActiveRecipe(recipe)
                                  }}
                                >
                                  Nutritional Information
                                </button>
                                {showRecipePrices && (
                                  <>
                                    {getRecipePrice(recipe?.itemId) && (
                                      <div className="mx-auto flex flex-col items-center justify-center text-center">
                                        <p className="text-base md:text-xl font-bold text-primary">
                                          £{getRecipePrice(recipe.itemId)}
                                        </p>
                                      </div>
                                    )}
                                  </>
                                )}
                                <div className="flex items-center justify-center mb-4">
                                  {getRecipeQuantity(recipe.itemId) > 0 && (
                                    <button
                                      type="button"
                                      className={`btn-cta mr-2 xs:mr-4 flex h-10 w-10 items-center !px-0 !py-0 !text-4xl disabled:bg-[#D1D5DA]`}
                                      onClick={() => handleRemoveRecipe(recipe.itemId)}
                                    >
                                      <span className="mb-[6px]">-</span>
                                    </button>
                                  )}
                                  {getRecipeQuantity(recipe.itemId) > 0 && (
                                    <Field
                                      name="recipe"
                                      type="text"
                                      placeholder="0"
                                      className="w-1/3 rounded-3xl border border-gray-300 py-3 px-4 text-center shadow-sm focus:border-primary focus:ring-primary"
                                      value={getRecipeQuantity(recipe.itemId)}
                                      inputMode="none"
                                      onFocus={(e: any) => e.target.blur()}
                                    />
                                  )}
                                  {getRecipeQuantity(recipe.itemId) > 0 && (
                                    <button
                                      type="button"
                                      className={`btn-cta ml-2 xs:ml-4 flex h-10 w-10 items-center !px-0 !py-0 !text-4xl disabled:cursor-not-allowed disabled:bg-[#D1D5DA] disabled:grayscale disabled:filter`}
                                      onClick={() => handleAddRecipe(recipe.itemId)}
                                      disabled={maxRecipeLimit}
                                    >
                                      +
                                    </button>
                                  )}
                                  {getRecipeQuantity(recipe.itemId) === 0 && (
                                    <div className="relative group w-full">
                                      {packSize === 0 && (
                                        <div
                                          role="tooltip"
                                          aria-hidden={packSize > 0}
                                          className="absolute bottom-full left-1/2 w-11/12 mx-auto -translate-x-1/2 bg-white rounded-xl px-3 py-2 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition duration-200 pointer-events-none z-10 font-sans font-medium text-black text-xs sm:text-sm"
                                        >
                                          Please select a pack size
                                        </div>
                                      )}
                                      <button
                                        type="button"
                                        disabled={maxRecipeLimit || packSize === 0}
                                        className={`btn-cta !px-8 !text-base !text-white disabled:cursor-not-allowed disabled:bg-[#D1D5DA]`}
                                        onClick={() => handleAddRecipe(recipe.itemId)}
                                      >
                                        {'Add'}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </li>
                          )
                        })}
                  </ul>
                </div>
              </div>
            )
          }}
        </Formik>
      </div>
    )
  }

  const renderAddonSection = () => {
    return (
      <div className={`fade-in flex center mt-4 mb-6 rounded-3xl bg-white lg:w-full container`}>
        <Formik
          initialValues={{ addons: [] }}
          validationSchema={TreatsSchema}
          onSubmit={() => {
            dispatch(addAddons(addons))
          }}
          validateOnMount
        >
          {props => {
            return (
              <div className={`relative my-4`}>
                <p className="font-sans font-semibold text-base text-center mx-auto pt-4">Treats &amp; Extras</p>

                <div className={`p-2 pt-3 lg:py-4 w-full mx-auto lg:w-auto`}>
                  <ul className="mx-auto grid w-full gap-y-6 gap-x-4 xs:gap-x-8 xs:p-4 pt-0 grid-cols-2 md:max-w-[80%] lg:grid-cols-3">
                    {addonList &&
                      addonList
                        .filter(
                          addon =>
                            addon.status !== 'OUTOFSTOCK' &&
                            filteredStoreAddonIds.some((a: any) => a.itemId === addon.itemId)
                        )
                        .map((addon: { itemId: string; name: string; imageUrlNormal: string }, _key: number) => {
                          const selectedAddon = addons?.find(r => r.id === addon.itemId)

                          return (
                            <li
                              className={`relative overflow-hidden rounded-3xl bg-[#F8F2EC] ${selectedAddon && 'shadow-[0_0_0_4px_rgba(0,102,133,1)]'}`}
                              key={addon.itemId}
                            >
                              <div className={`flex h-full flex-col justify-between text-center`}>
                                <div className="flex h-full flex-col">
                                  <div className="block grid-cols-3 md:grid md:grid-cols-1">
                                    <div className="aspect-h-1 relative mx-auto w-full overflow-hidden md:rounded-none lg:h-[180px] xl:h-[220px]">
                                      {addon?.images?.tertiary && (
                                        <CdnImage
                                          url={addon?.images?.tertiary}
                                          alt={addon.name}
                                          steps={[550]}
                                          className={`max-h-[100px] md:max-h-[150px] w-full scale-150 transform object-contain md:object-cover lg:max-h-full md:scale-100 block bg-[#F6E9DB]`}
                                        />
                                      )}
                                    </div>
                                    <div className="col-span-2 flex h-auto flex-grow flex-col">
                                      <div className="col-span-2 flex h-auto flex-grow flex-col py-4 px-1 xs:p-4">
                                        <h4 className="font-sans font-semibold text-center md:text-xl">{addon.name}</h4>
                                        <p className="mt-4 flex h-full flex-grow flex-col text-center text-xs text-black md:text-sm">
                                          {addon.shortDescription}{' '}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <button
                                  className="pb-2.5 text-xs text-black underline sm:text-sm"
                                  onClick={() => {
                                    setModalShow(true)
                                    setModalActiveRecipe(addon)
                                  }}
                                >
                                  Nutritional Information
                                </button>
                                {showRecipePrices && (
                                  <>
                                    {getAddonPrice(addon?.itemId) && (
                                      <div className="mx-auto flex flex-col items-center justify-center text-center">
                                        <p className="text-base md:text-xl font-bold text-primary">
                                          £{getAddonPrice(addon.itemId)}
                                        </p>
                                      </div>
                                    )}
                                  </>
                                )}
                                <div className="flex items-center justify-center mb-4">
                                  {getAddonQuantity(addon.itemId) > 0 && (
                                    <button
                                      type="button"
                                      className={`btn-cta mr-2 xs:mr-4 flex h-10 w-10 items-center !px-0 !py-0 !text-4xl disabled:bg-[#D1D5DA]`}
                                      onClick={() => handleRemoveAddon(addon.itemId)}
                                    >
                                      <span className="mb-[6px]">-</span>
                                    </button>
                                  )}
                                  {getAddonQuantity(addon.itemId) > 0 && (
                                    <Field
                                      name="addon"
                                      type="text"
                                      placeholder="0"
                                      className="w-1/3 rounded-3xl border border-gray-300 py-3 px-4 text-center shadow-sm focus:border-primary focus:ring-primary"
                                      value={getAddonQuantity(addon.itemId)}
                                      inputMode="none"
                                      onFocus={(e: any) => e.target.blur()}
                                    />
                                  )}
                                  {getAddonQuantity(addon.itemId) > 0 && (
                                    <button
                                      type="button"
                                      className={`btn-cta ml-2 xs:ml-4 flex h-10 w-10 items-center !px-0 !py-0 !text-4xl disabled:cursor-not-allowed disabled:bg-[#D1D5DA] disabled:grayscale disabled:filter`}
                                      onClick={() => handleAddAddon(addon.itemId)}
                                    >
                                      +
                                    </button>
                                  )}
                                  {getAddonQuantity(addon.itemId) === 0 && (
                                    <div className="relative group w-full">
                                      <button
                                        type="button"
                                        className={`btn-cta !px-8 !text-base !text-white disabled:cursor-not-allowed disabled:bg-[#D1D5DA]`}
                                        onClick={() => handleAddAddon(addon.itemId)}
                                      >
                                        {'Add'}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </li>
                          )
                        })}
                  </ul>
                </div>
              </div>
            )
          }}
        </Formik>
      </div>
    )
  }

  const renderCTAButton = () => {
    return (
      <div className="flex flex-col center w-full">
        <button
          type="button"
          disabled={loading || recipeCount === 0}
          className={`flex w-11/12 items-center justify-center mx-auto rounded-full border border-transparent bg-[#006685] px-5 py-3 text-base font-medium text-white md:w-96 md:text-lg ${isSubmitting || recipeCount === 0 ? 'opacity-50' : ''}`}
          onClick={handleSubmitToCheckout}
        >
          {buttonProp?.buttonText}
          <FontAwesomeIcon icon={faChevronRight} className="h-4 w-4 ml-2" aria-hidden="true" />
        </button>
      </div>
    )
  }

  const renderButtonMessage = () => {
    return <p dangerouslySetInnerHTML={{ __html: buttonMessage }}></p>
  }

  return (
    <>
      {/* Desktop header */}
      {(topBanner || topImage) && (
        <div
          className="relative w-full bg-cover bg-top bg-no-repeat hidden h-32 lg:block mt-16"
          style={{
            backgroundImage: topBanner ? `url(${topBanner})` : 'none'
          }}
        >
          {topImage && (
            <CdnImage
              className="absolute left-1/2 top-0 transform -translate-x-1/2 -translate-y-1/2 w-[26rem] z-20 hidden lg:block"
              url={topImage}
              alt={topImageAlt}
            />
          )}
        </div>
      )}

      {/* Mobile header */}
      {topImageMobile && <CdnImage className="w-full h-full block lg:hidden" url={topImageMobile} alt={topImageAlt} />}
      <div
        className="relative w-full bg-cover bg-top bg-no-repeat h-16 block lg:hidden my-[-2rem]"
        style={{
          backgroundImage: topBannerMobile ? `url(${topBannerMobile})` : 'none'
        }}
      />

      <main className="relative mx-auto flex w-full flex-col z-10">
        <div
          className={`mx-auto h-full w-full flex flex-col justify-center items-center pt-4 lg:pt-1`}
          style={{ backgroundColor: backgroundColor }}
        >
          {renderText()}

          {showTrustpilotImage && <div className="w-full py-2 lg:-mt-2 mb-2">{getWidget()}</div>}

          {renderFormSection()}

          {shopRouteConfiguration.heading && (
            <div className="" dangerouslySetInnerHTML={{ __html: shopRouteConfiguration.heading }} />
          )}
          {shopRouteConfiguration.subHeading && (
            <div className="" dangerouslySetInnerHTML={{ __html: shopRouteConfiguration.subHeading }} />
          )}
          <div className="w-11/12 lg:w-auto 2xl:container">
            {shopRouteConfiguration.displaySizes && renderBundles()}

            {showAllRecipes && renderRecipeSection()}
            {showAllAddons && renderAddonSection()}

            {renderCTAButton()}
            {renderButtonMessage()}
          </div>
        </div>
      </main>
      {/* Desktop footer image */}
      {footerImage && (
        <div
          className="relative w-full bg-cover bg-top bg-no-repeat h-24 mb:4 md:mb-4 -mt-2 md:-mt-4 hidden lg:block"
          style={{
            backgroundImage: `url(${footerImage})`
          }}
        />
      )}
      {/* Mobile footer image */}
      {footerImageMobile && (
        <div
          className="relative w-full bg-cover bg-top bg-no-repeat h-24 mb:4 md:mb-4 -mt-2 md:-mt-4 block lg:hidden"
          style={{
            backgroundImage: `url(${footerImageMobile})`
          }}
        />
      )}
      {showStickyFooter && (
        <div className="fixed bottom-0 inset-x-0 z-[50] h-20 bg-[#F8F2EC] bg-opacity-75 backdrop-blur-sm w-full lg:w-11/12 mx-auto lg:rounded-t-3xl shadow-[0_-5px_15px_rgba(0,0,0,0.25)] flex items-center justify-center">
          <div className="w-11/12 lg:w-1/2 flex justify-center">{renderCTAButton()}</div>
        </div>
      )}
      <RecipeOrTreatAlterModal show={modalShow} setShow={setModalShow} activeRecipe={modalActiveRecipe} />
    </>
  )
}

export default ShopRouteAlternate

Builder.registerComponent(ShopRouteAlternate, {
  name: 'ShopRouteAlternate',
  inputs: [
    {
      name: 'route',
      type: 'text',
      enum: ['sample', 'shop'],
      defaultValue: ''
    },
    {
      name: 'shopRouteConfiguration',
      type: 'object',
      defaultValue: {
        heading: '',
        subHeading: '',
        flexibleQuantity: false
      },
      subFields: [
        {
          name: 'packs',
          type: 'array',
          defaultValue: [],
          subFields: [
            { name: 'name', type: 'string', defaultValue: '' },
            { name: 'description', type: 'richText', defaultValue: '' },
            {
              name: 'packImage',
              type: 'file',
              allowedFileTypes: ['jpeg', 'png', 'svg']
            },
            { name: 'packImageAlt', type: 'string', defaultValue: '' },
            { name: 'size', type: 'string', enum: ['250', '600', '1000'], defaultValue: '' },
            { name: 'quantity', type: 'number', defaultValue: 0 }
          ]
        },
        { name: 'heading', type: 'richText', defaultValue: '' },
        { name: 'subHeading', type: 'richText', defaultValue: '' },
        { name: 'flexibleQuantity', type: 'boolean', defaultValue: true },
        { name: 'displaySizes', type: 'boolean', defaultValue: true },
        { name: 'preSelectPack', type: 'boolean', defaultValue: true }
      ]
    },
    { name: 'showAllRecipes', type: 'boolean', defaultValue: true },
    {
      name: 'recipesAvailable',
      type: 'list',
      defaultValue: [
        {
          itemId: null
        }
      ],
      subFields: [{ name: 'itemId', type: 'text', defaultValue: '' }]
    },
    {
      name: 'bloopersAvailable',
      type: 'list',
      defaultValue: [
        {
          itemId: null
        }
      ],
      subFields: [{ name: 'itemId', type: 'text', defaultValue: '' }]
    },
    { name: 'showPrices', type: 'boolean', defaultValue: false },
    { name: 'showAllAddons', type: 'boolean', defaultValue: true },
    {
      name: 'addonsAvailable',
      type: 'list',
      defaultValue: [
        {
          itemId: null
        }
      ],
      subFields: [{ name: 'itemId', type: 'text', defaultValue: '' }]
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'mainHeading',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'mainHeadingColor',
      type: 'color',
      defaultValue: '#006685'
    },
    {
      name: 'mainSubheading',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'center'
    },
    {
      name: 'topBanner',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topBannerMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topImageMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    { name: 'topImageAlt', type: 'string', defaultValue: '' },
    {
      name: 'footerImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'footerImageMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'showTrustpilotImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'widgetColor',
      type: 'color',
      defaultValue: '#004355'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    { name: 'buttonMessage', type: 'richText', defaultValue: '' }
  ]
})
